import BASE_64_TRANSPARENT_GIF_SRC from '../../../constants/base64TransparentGifSrc';
import StyledSportIcon from './StyledSportIcon';

export const iconPlaceholder = props => (
  <StyledSportIcon
    src={BASE_64_TRANSPARENT_GIF_SRC}
    name="Placeholder"
    {...props}
  />
);
